<template>
  <!-- [sc-49299] Spese aggiuntive del preventivo: senza IVA, una per voce.
       null = voce non spuntata, stringa = importo (anche vuoto, da scrivere) -->
  <section class="spese-aggiuntive">
    <h4 class="spese-aggiuntive__titolo">
      Spese aggiuntive <small>(senza IVA)</small>
    </h4>

    <div v-for="v in voci" :key="v.campo" class="spesa-voce">
      <label class="spesa-voce__check">
        <input
          type="checkbox"
          :checked="attiva(v.campo)"
          @change="spunta(v.campo, $event.target.checked)"
        />
        {{ v.label }}
      </label>

      <div class="spesa-voce__importo">
        <input
          :id="`spesa-${v.campo}`"
          type="text"
          inputmode="decimal"
          :value="modelValue[v.campo] ?? ''"
          :disabled="!attiva(v.campo)"
          :aria-label="`Importo ${v.label}`"
          placeholder="0,00"
          :class="{ invalid: errore(v.campo) }"
          @input="imposta(v.campo, $event.target.value)"
        />
        <span>€</span>
      </div>

      <small v-if="errore(v.campo)" class="help-error">{{
        errore(v.campo)
      }}</small>
    </div>
  </section>
</template>

<script>
import { VOCI_SPESA, erroreSpesa } from "@/utilities/spese";

export default {
  name: "SpeseAggiuntive",
  props: {
    // { shipping_cost, delivery_cost, packaging_cost }
    modelValue: { type: Object, required: true },
  },
  emits: ["update:modelValue"],
  data() {
    return { voci: VOCI_SPESA };
  },
  methods: {
    attiva(campo) {
      return (
        this.modelValue[campo] !== null && this.modelValue[campo] !== undefined
      );
    },
    errore(campo) {
      return erroreSpesa(this.modelValue[campo]);
    },
    imposta(campo, valore) {
      this.$emit("update:modelValue", { ...this.modelValue, [campo]: valore });
    },
    spunta(campo, attiva) {
      this.imposta(campo, attiva ? "" : null);
      if (attiva) {
        this.$nextTick(() =>
          document.getElementById(`spesa-${campo}`)?.focus()
        );
      }
    },
  },
};
</script>

<style>
.spese-aggiuntive {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.spese-aggiuntive__titolo {
  margin: 0;
  font-size: 15px;
}

.spese-aggiuntive__titolo small {
  font-weight: 400;
  color: var(--modal-muted);
}

.spese-aggiuntive .spesa-voce {
  display: grid;
  grid-template-columns: 140px 160px 1fr;
  align-items: center;
  gap: 12px;
}

.spese-aggiuntive .spesa-voce__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.spese-aggiuntive .spesa-voce__check input {
  width: auto;
  margin: 0;
  accent-color: var(--brand);
}

.spese-aggiuntive .spesa-voce__importo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.spese-aggiuntive .spesa-voce__importo input {
  width: 120px;
  text-align: right;
}

.spese-aggiuntive .spesa-voce__importo input:disabled {
  background: #f4f4f5;
  cursor: not-allowed;
}

.spese-aggiuntive .spesa-voce__importo input.invalid {
  border-color: #e6492d;
}

.spese-aggiuntive .help-error {
  color: #e6492d;
  font-size: 12px;
}

@media (max-width: 520px) {
  .spese-aggiuntive .spesa-voce {
    grid-template-columns: 1fr auto;
  }

  .spese-aggiuntive .help-error {
    grid-column: 1 / -1;
  }
}
</style>
